if (!customElements.get('dkt-image-compare')) {
  customElements.define('dkt-image-compare', class extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type="range"]');
      this.controls = this.querySelector('.dktc__controls');
      this.toggle = this.querySelector('.dktc__autoplay');
      if (!this.range || !this.controls || !this.toggle) return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.stopFrame();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = this.querySelectorAll('[data-reveal]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.elapsed = 0;
      this.lastValue = null;
      this.range.addEventListener('pointerdown', () => this.pause(), options);
      this.range.addEventListener('focus', () => this.pause(), options);
      this.range.addEventListener('input', () => {
        this.pause();
        this.renderValue(Number(this.range.value));
      }, options);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.pause();
        this.renderValue(Number(button.dataset.reveal));
      }, options));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        if (!this.paused) {
          const value = Number(this.range.value);
          this.elapsed = 1500 + Math.acos(Math.max(-1, Math.min(1, value / 50 - 1))) * 2000 / Math.PI;
        }
        this.syncPlayback();
      }, options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.pause();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        this.syncPlayback();
      }, { threshold: [0, 0.25] });
      this.observer.observe(this.querySelector('.dktc__stage'));
      this.range.hidden = false;
      this.controls.hidden = false;
      this.toggle.hidden = false;
      this.setAttribute('data-ready', '');
      this.renderValue(this.paused ? 50 : 100);
      this.syncPlayback();
    }
    renderValue(value) {
      value = Math.round(Math.max(0, Math.min(100, value)));
      if (value === this.lastValue) return;
      this.lastValue = value;
      this.range.value = String(value);
      this.style.setProperty('--compare-position', `${value}%`);
      this.range.setAttribute('aria-valuetext', `${value}% ${this.dataset.before}, ${100 - value}% ${this.dataset.after}`);
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.reveal) === value)));
    }
    pause() {
      this.paused = true;
      this.syncPlayback();
    }
    stopFrame() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = null;
    }
    syncPlayback() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      const running = !this.paused && this.visible && !document.hidden;
      this.dataset.autoplay = running ? 'playing' : 'paused';
      if (!running) this.stopFrame();
      else if (!this.frame) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (this.lastTime !== null) this.elapsed = (this.elapsed + Math.min(time - this.lastTime, 100)) % 8000;
      this.lastTime = time;
      const t = this.elapsed;
      const ease = progress => (1 - Math.cos(Math.PI * progress)) / 2;
      let value = 100;
      if (t >= 1500 && t < 3500) value = 100 * (1 - ease((t - 1500) / 2000));
      else if (t >= 3500 && t < 5000) value = 0;
      else if (t >= 5000 && t < 7000) value = 100 * ease((t - 5000) / 2000);
      this.renderValue(value);
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.stopFrame();
    }
  });
}
